export enum RoleId {
  LTL_PRO_IT_ADMIN = '416',
  TST_LTL_PRO_IT_ADMIN = '419',
  LTL_PRO_CS_ADMIN = '415',
  TST_LTL_PRO_CS_ADMIN = '418',
}
